<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>
<div class="dark-mode">
  <mat-slide-toggle
    [checked]="darkMode"
    (change)="onDarkModeChange()"
    [disabled]="readOnlyContent"
  >
    Dark Mode
  </mat-slide-toggle>
</div>
<div class="chart-reference-container">
  <div
    [ngClass]="
      darkMode ? 'reference-container-dark' : 'reference-container-light'
    "
  >
    <div [ngClass]="darkMode ? 'reference-dark' : 'reference-light'">
      <div class="dogleg">Dogleg</div>
      <div class="square-container">
        <span class="squares-reference legend-color-1"></span>
        <span>&lt; 0.46</span>
      </div>
      <div class="square-container">
        <span class="squares-reference legend-color-2"></span>
        <span>0.46 - 0.93</span>
      </div>
      <div class="square-container">
        <span class="squares-reference legend-color-3"></span>
        <span>0.93 - 1.4</span>
      </div>
      <div class="square-container">
        <span class="squares-reference legend-color-4"></span>
        <span>1.4 - 1.9</span>
      </div>
      <div class="square-container">
        <span class="squares-reference legend-color-5"></span>
        <span>1.9 - 2.3</span>
      </div>
      <div class="square-container">
        <span class="squares-reference legend-color-6"></span>
        <span>2.3 - 2.8</span>
      </div>
      <div class="square-container">
        <span class="squares-reference legend-color-7"></span>
        <span>&ge; 2.8</span>
      </div>
    </div>
  </div>
  <div class="chart-panel">
    <div
      #chartContainer
      [ngClass]="
        darkMode ? 'chart-container dark-bg' : 'chart-container light-bg'
      "
    ></div>
  </div>
</div>
<div class="path-tb-container">
  <h3>Datos Trayectoria</h3>
  <div class="path-tb-w">
    <table class="path-tb">
      <thead>
        <tr>
          <th>Sequence</th>
          <th>MD</th>
          <th>Inc</th>
          <th>Azi</th>
          <th>TVD</th>
          <th>N/S</th>
          <th>E/W</th>
          <th>Dogleg</th>
        </tr>
      </thead>
      <tbody #tableBody>
        @for(i of getTableIndexes(); track $index;) {
        <tr
          #rowRef
          (click)="onRowClick(i)"
          [ngStyle]="{
            background:
              selectedIndex === i
                ? surveyData.dogleg[i] > 2.8
                  ? '#f7a4a4'
                  : '#999797'
                : surveyData.dogleg[i] > 2.8
                ? '#ffdddd'
                : 'inherit',
            color: selectedIndex === i ? '#fff' : 'inherit',
            cursor: 'pointer'
          }"
        >
          <td>
            {{ surveyData.sequence[i] }}
          </td>
          <td>
            {{ surveyData.md[i] }}
          </td>
          <td>
            {{ surveyData.inc[i] }}
          </td>
          <td>
            {{ surveyData.azi[i] }}
          </td>
          <td>
            {{ surveyData.tvd[i] }}
          </td>
          <td>
            {{ surveyData.ns[i] }}
          </td>
          <td>
            {{ surveyData.ew[i] }}
          </td>
          <td>
            {{ surveyData.dogleg[i] }}
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>
